import Model  from '@/utils/models';

export default class Product extends Model { 
    backend = '/survey/calon/';           

    uploadImage(formdata, params={}){
        return this.api.post(this.backend + 'upload-image', formdata, params, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }

    partaies(params={}){
      return this.api.get('/survey/partai/index', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    kompetisies(params={}){
      return this.api.get('/survey/kompetisi/index', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    partai(params={}){
      return this.api.get('/survey/partai/view', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    kompetisi(params={}){
      return this.api.get('/survey/kompetisi/view', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }
}

